import React, { useState, useEffect } from 'react';
import { Tabs, message } from 'antd';
import TablaEstadoCuenta from './TablaEstadoCuenta';
import axios from "./../../services/http";

const TabsEstadoCuenta = ({ filters }) => {

    const [loading, setLoading] = useState(false);
    const [tipoMonto, setTipoMonto] = useState('Fiscal');
    const [estadoCuenta, setEstadoCuenta] = useState([]);

    useEffect(() => {
        GetEstadoCuenta();
    }, [tipoMonto, filters]);

    const GetEstadoCuenta = async () => {
        try {
            const response = await axios.HTTP_POST(`/api/v1/accountStatement/${tipoMonto}`, filters);
            setEstadoCuenta(response.data);
            
        } catch (error) {
            console.error('Error al cargar el estado de cuenta:', error);
            message.error('Error al cargar el estado de cuenta: ', error);
        } finally {
            setLoading(false);
        }
    }

    const onChangeTab = (key) => {
        setTipoMonto(key === '1' ? 'Fiscal' : 'No Fiscal');
        setLoading(true);
    }

    const items = [
        {
            key: '1',
            label: 'Fiscal',
            children: <TablaEstadoCuenta loading={loading} estadoCuenta={estadoCuenta} />
        },
        {
            key: '2',
            label: 'No Fiscal',
            children: <TablaEstadoCuenta loading={loading} estadoCuenta={estadoCuenta} />
        },
    ];

    return (
        <>
            <Tabs 
                defaultActiveKey="1" 
                items={items} 
                onChange={(index) => onChangeTab(index)}
            />
        </>
    )
}

export default TabsEstadoCuenta;